import React, { useState } from "react";

const CriticalGizmo = ({isOpen}) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      style={{ cursor: "pointer" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      {isOpen ? (
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="11" cy="11" r="11" fill="#FC0000"/>
</svg>

 
      ) :
      isHovered ? (
        // Hover SVG
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="11" cy="11" r="11" fill="#FC0000"/>
</svg>

      ) : (
        // Default SVG
        <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
<circle cx="11" cy="11" r="11" fill="#FC0000"/>
</svg>

      )}
    </div>
  )
}

export default CriticalGizmo
